(function () {
  const DEFAULT_ZOOM = 2.5;
  const DEFAULT_LENS_SIZE = 220;

  function initMagnifier(wrap) {
    if (wrap.dataset.circularMagnifierReady === 'true') return;
    wrap.dataset.circularMagnifierReady = 'true';

    const img = wrap.querySelector('.circular-magnifier__image');
    const lens = wrap.querySelector('[data-circular-magnifier-lens]');
    const lensImg = wrap.querySelector('[data-circular-magnifier-lens-image]');
    if (!img || !lens || !lensImg) return;

    const zoom = parseFloat(wrap.dataset.zoom) || DEFAULT_ZOOM;
    const lensSize = parseInt(wrap.dataset.lensSize, 10) || DEFAULT_LENS_SIZE;
    const radius = lensSize / 2;

    lens.style.width = `${lensSize}px`;
    lens.style.height = `${lensSize}px`;

    const syncLensImage = () => {
      lensImg.src = img.currentSrc || img.src;
    };

    const hide = () => {
      lens.hidden = true;
      wrap.classList.remove('is-magnifying');
    };

    const move = (event) => {
      const rect = wrap.getBoundingClientRect();
      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;

      if (x < 0 || y < 0 || x > rect.width || y > rect.height) {
        hide();
        return;
      }

      lens.hidden = false;
      wrap.classList.add('is-magnifying');
      lens.style.transform = `translate(${x - radius}px, ${y - radius}px)`;

      const scaledWidth = rect.width * zoom;
      const scaledHeight = rect.height * zoom;

      lensImg.style.width = `${scaledWidth}px`;
      lensImg.style.height = `${scaledHeight}px`;
      lensImg.style.transform = `translate(${-(x * zoom - radius)}px, ${-(y * zoom - radius)}px)`;
    };

    syncLensImage();
    img.addEventListener('load', syncLensImage);
    wrap.addEventListener('mouseenter', syncLensImage);
    wrap.addEventListener('mouseleave', hide);
    wrap.addEventListener('mousemove', move);
  }

  function initAll() {
    if (!window.matchMedia('(hover: hover)').matches) return;
    document.querySelectorAll('[data-circular-magnifier]').forEach(initMagnifier);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
